// ? Valores para produccion
export const environment = {
  production: false,
  apiUrl: 'https://api.devjobpointme.claro.com.gt/JobPointAPI/',
  cdnAssetsUrl: 'assets/',
  mapbox: {
    accessToken:
      'pk.eyJ1IjoiaGFuc3NhYmluYWRpZSIsImEiOiJjbGlremI5MXUwanQzM3JwYmlrZGN0Y3Y0In0.tHEkbeN8o55Mxh_8J0EsSA',
  },
  apiKey: 'AIzaSyCV3HUoJ80tkDkoFcHXu-eKZ0luM_3eB08',
  microsoftAuth: {
    clientId: 'f5490f68-273e-4a78-95bc-64b9ccb227aa',
    tenantId: '4a261f89-8ec8-47cb-9e42-747c3eb3757f'
  }
};